import React, { FunctionComponent, useEffect, useState, useRef } from 'react'
import { Form, Button, message, Carousel } from 'antd'
import { CarouselRef } from 'antd/es/carousel'
import { AppStore } from 'src/pc/store/AppStore'
import { hot } from 'react-hot-loader/root'
import { observer } from 'mobx-react'
import { MobileOutlined, SafetyOutlined } from '@ant-design/icons'
import { GetChannel } from 'src/commons/utils/index'
import { successByLoginPage, SendPhoneCodeAndCheck, doUserLogin } from 'src/pc/store/UserStore'
import {
  DWGetModDataByModIdHttp,
  DWCMSVersionHttp,
  getAuthCodeHttpHS,
  checkOfficeLoginHttpHS,
  phoneLoginBindWXHS,
  ChannelConfigHS,
} from 'src/commons/store/BasisStore'
import { PhonePattern } from 'src/commons/utils'
import { PageMini, pageClose, showAgreementModal, OpenCustomerService } from 'src/pc/store/UIController'
import DDInput from 'src/pc/components/dd-input'
import DDButton from 'src/pc/components/DDButton'
import PhoneInput from 'src/pc/components/PhoneInput'
import DDImage from 'src/pc/components/dd-image'
import PhoneCaptchaInput from 'src/pc/components/PhoneCaptchaInput'
import styled from 'styled-components'
import useSendCode from 'src/pc/components/hooks/useSendCode'
import WeixinLogin from 'src/pc/assets/icons/weixinLogin.svg'
import PhoneLogin from 'src/pc/assets/icons/shouji.svg'
import logo from 'src/pc/assets/images/login/logo.png'
import leftImg from 'src/pc/assets/images/login/left.png'
import rightImg from 'src/pc/assets/images/login/right.png'
import loginImg from 'src/pc/assets/images/login/loginBg.png'
import CloseIcon from 'src/pc/assets/icons/closeMenu.svg'
import MinimizeIcon from 'src/pc/assets/icons/minimize.svg'

let timer: any = null
const Login: FunctionComponent = () => {
  const carouselRef = useRef<CarouselRef>(null)
  const [form] = Form.useForm()
  const [loading, setLoading] = useState<boolean>(false)
  const [loginType, setLoginType] = useState<'wechat' | 'phone' | 'bindPhone'>('phone')
  const [overdue, setOverdue] = useState<boolean>(true)
  const [wechatQRcode, setWechatQRcode] = useState<string>('')
  const [WXToken, setWXToken] = useState<string>('')
  const [sceneId, setSceneId] = useState<string>('')
  const [bannerList, setBannerList] = useState<{ img: string; sort: string }[] | null>(null)
  const { validateFields, resetFields, getFieldValue } = form
  const { sendCode, text: sendCodeText, isLoading: sendCodeLoading } = useSendCode('获取验证码')
  const channelConfig = ChannelConfigHS.SuccessResult

  const getInit = async () => {
    const cmsVersionResult = await DWCMSVersionHttp.Execute()
    const version = `${cmsVersionResult}_${location.host}`
    DWGetModDataByModIdHttp.Execute({ modId: 'simpleshq_new_sale_protocol', version }).then(
      (data: ModData<{ keyword: AgreementType; title: string; content: string }>) => {
        data.datas.forEach(d => {
          AppStore.AgreementConfig[d.properties.keyword] = { title: d.properties.title, content: d.properties.content }
        })
      },
    )

    DWGetModDataByModIdHttp.Execute({ modId: 'simpleshq_login_banner', version }).then(
      (data: ModData<{ img: string; sort: string }>) => {
        const filterBannerList = data.datas.map(d => d.properties).sort((a, b) => Number(a.sort) - Number(b.sort))
        setBannerList(filterBannerList)
      },
    )
  }
  const getWeiXinLoginQRCode = async () => {
    const { sceneId, url } = await getAuthCodeHttpHS.Execute({ channel: GetChannel() })
    setOverdue(false)
    setWechatQRcode(url)
    startCountdown(sceneId, 60 * 1.5)
  }

  const startCountdown = (sceneId: string, count: number) => {
    timer && clearTimeout(timer)
    if (count === 0) {
      setOverdue(true)
      return
    }
    timer = setTimeout(async () => {
      const result = await checkOfficeLoginHttpHS.Execute({ sceneId, channel: GetChannel() })
      if (result) {
        /** 扫描二维码 */
        timer && clearTimeout(timer)
        if (!result.bindMobile) {
          /** 没有绑定手机号 */
          setLoginType('bindPhone')
          setSceneId(sceneId)
          setWXToken(result.token)
        } else {
          setLoginType('phone')
          resetFields()
          successByLoginPage(result.token)
        }
        setOverdue(true)
        setWechatQRcode('')
        timer = null
      } else {
        startCountdown(sceneId, --count)
      }
    }, 1000)
  }
  const userLogin = async () => {
    setLoading(true)
    validateFields(['Phone', 'Code']).then(values => {
      doUserLogin({ account: values.Phone, password: values.Code, type: 2, channel: GetChannel() })
        .then(async res => {
          resetFields()
          setTimeout(() => {
            setLoading(false)
          }, 1000)
        })
        .catch(res => {
          setTimeout(() => {
            setLoading(false)
          }, 1000)
          message.warning(res.message)
        })
    })
  }

  const getPhoneCaptcha = () => {
    validateFields(['Phone']).then(values => {
      SendPhoneCodeAndCheck({
        mobile: values.Phone,
        action: 4,
        captcha_type: 3,
      }).catch(res => {
        message.warning(res)
      })
    })
  }
  const bindPhone = () => {
    setLoading(true)
    validateFields(['bindPhone', 'bindCode']).then(values => {
      phoneLoginBindWXHS
        .Execute({ mobile: values.bindPhone, mobileCode: values.bindCode, sceneId, channel: GetChannel() })
        .then(res => {
          successByLoginPage(WXToken)
          resetFields()
          setTimeout(() => {
            setLoading(false)
          }, 1000)
        })
        .catch(err => {
          message.warn(err.message)
          setTimeout(() => {
            setLoading(false)
          }, 1000)
        })
    })
  }
  const preBanner = () => {
    carouselRef.current && carouselRef.current.prev()
  }
  const nextBanner = () => {
    carouselRef.current && carouselRef.current.next()
  }
  useEffect(() => {
    getInit()
    return () => {
      timer && clearTimeout(timer)
      setLoginType('phone')
      resetFields()
      setOverdue(true)
      setWechatQRcode('')
      timer = null
    }
  }, [])
  useEffect(() => {
    if (overdue && loginType === 'wechat' && wechatQRcode === '') {
      timer && clearTimeout(timer)
      timer = null
      getWeiXinLoginQRCode()
    }
  }, [overdue, loginType, wechatQRcode])

  return (
    <>
      <div id="Login">
        <div className="drag top" />
        <div className="left">
          {!!(bannerList && bannerList?.length > 1) && (
            <>
              <div className="changeBtns">
                <img draggable={false} onClick={() => preBanner()} src={leftImg} />
                <img draggable={false} onClick={() => nextBanner()} src={rightImg} />
              </div>
              <Carousel autoplay autoplaySpeed={3000} ref={carouselRef}>
                {bannerList.map((d, i) => (
                  <div key={i}>
                    <StyledImgBox>
                      <DDImage src={d.img} />
                    </StyledImgBox>
                  </div>
                ))}
              </Carousel>
            </>
          )}
          {!!(bannerList && bannerList?.length === 1) && (
            <div className="imgBox">
              <img draggable={false} src={bannerList[0].img} />
            </div>
          )}
        </div>
        <div className="right" style={{ backgroundImage: `url(${loginImg})` }}>
          <div className="btnBox">
            <div className="notDrag action" onClick={PageMini}>
              <MinimizeIcon className="icon" />
            </div>
            <div className="notDrag action" onClick={pageClose}>
              <CloseIcon className="icon" />
            </div>
          </div>
          <div className="notDrag logo">
            <DDImage src={channelConfig?.startLoginImg || logo} />
          </div>
          <div className="notDrag loginContent">
            {loginType === 'phone' && (
              <Form className="custom" onFinish={userLogin} form={form}>
                <PhoneInput />
                <PhoneCaptchaInput GetPhoneCaptcha={getPhoneCaptcha} />
                <StyledAgreementRow>
                  登录/注册即代表同意
                  <span onClick={() => showAgreementModal('zhuce')}>《{AppStore.AgreementConfig.zhuce?.title}》</span>
                </StyledAgreementRow>
                <Form.Item style={{ marginBottom: 0 }}>
                  <DDButton
                    loading={loading}
                    style={{ height: 38 }}
                    className="mainButton"
                    type="primary"
                    htmlType="submit"
                  >
                    点击登录
                  </DDButton>
                </Form.Item>
                <StyledLoginTypeBox>
                  <StyledCustomer onClick={() => OpenCustomerService(true)}>如遇问题，请联系客服</StyledCustomer>
                  <div className="text">
                    <div className="line" />
                    <span>其他登录方式</span>
                    <div className="line" />
                  </div>
                  <StyledSwitchRow>
                    <StyledSwitchBtn onClick={() => setLoginType('wechat')}>
                      <WeixinLogin />
                    </StyledSwitchBtn>
                  </StyledSwitchRow>
                </StyledLoginTypeBox>
              </Form>
            )}
            {loginType === 'wechat' && (
              <StyledWechatContainer>
                <StyledAgreementRow style={{ margin: '0 0' }}>
                  登录/注册即代表同意
                  <span onClick={() => showAgreementModal('zhuce')}>《{AppStore.AgreementConfig.zhuce?.title}》</span>
                </StyledAgreementRow>
                <StyledQrcodeContainer>
                  {overdue && (
                    <StyledQrcodeMark>
                      二维码已失效，
                      <span className="link" onClick={() => setWechatQRcode('')}>
                        重新获取
                      </span>
                    </StyledQrcodeMark>
                  )}
                  <StyledQrcodeBox>
                    {wechatQRcode && <img draggable={false} style={{ width: 123, height: 123 }} src={wechatQRcode} />}
                  </StyledQrcodeBox>
                </StyledQrcodeContainer>
                <StyledLoginTypeBox style={{ marginTop: 12 }}>
                  <StyledCustomer onClick={() => OpenCustomerService(true)}>如遇问题，请联系客服</StyledCustomer>
                  <div className="text">
                    <div className="line" />
                    <span>手机号登录</span>
                    <div className="line" />
                  </div>
                  <StyledSwitchRow>
                    <StyledSwitchBtn onClick={() => setLoginType('phone')}>
                      <PhoneLogin />
                    </StyledSwitchBtn>
                  </StyledSwitchRow>
                </StyledLoginTypeBox>
              </StyledWechatContainer>
            )}
            {loginType === 'bindPhone' && (
              <Form className="custom" onFinish={bindPhone} form={form}>
                <StyledWechatLoginTips>应游戏防沉迷相关规定 请绑定手机号再进行</StyledWechatLoginTips>
                <Form.Item
                  name="bindPhone"
                  rules={[
                    { required: true, message: '请输入手机号' },
                    { pattern: PhonePattern, message: '您输入的手机号不正确!' },
                  ]}
                  validateTrigger="onBlur"
                >
                  <DDInput autoComplete="off" placeholder="请输入手机号" prefix={<MobileOutlined />} />
                </Form.Item>
                <Form.Item name="bindCode" rules={[{ required: true, message: '请输入验证码!' }]}>
                  <DDInput
                    autoComplete="off"
                    placeholder="请输入验证码"
                    prefix={<SafetyOutlined />}
                    suffix={
                      <Button
                        disabled={!sendCodeLoading}
                        onClick={() => sendCode({ mobile: getFieldValue('bindPhone'), action: 5 })}
                      >
                        {sendCodeText}
                      </Button>
                    }
                  />
                </Form.Item>
                <StyledAgreementRow>
                  登录/注册即代表同意
                  <span onClick={() => showAgreementModal('zhuce')}>《{AppStore.AgreementConfig.zhuce?.title}》</span>
                </StyledAgreementRow>
                <Form.Item style={{ marginBottom: 0 }}>
                  <DDButton
                    loading={loading}
                    style={{ height: 38 }}
                    className="mainButton"
                    type="primary"
                    htmlType="submit"
                  >
                    点击登录
                  </DDButton>
                </Form.Item>
                <StyledCustomer onClick={() => OpenCustomerService(true)}>如遇问题，请联系客服</StyledCustomer>
              </Form>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
const StyledCustomer = styled.div`
  font-size: 12px;
  width: 100%;
  text-align: center;
  color: #ffcd54;
  text-decoration: underline;
  margin: 6px 0 22px;
  cursor: pointer;
`

const StyledQrcodeBox = styled.div`
  width: 123px;
  height: 123px;
  background: #fff;
`

const StyledQrcodeContainer = styled.div`
  width: 140px;
  height: 140px;
  border: 1px solid #525252;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  padding: 3px 3px;
`

const StyledQrcodeMark = styled.div`
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  background: rgba(0, 0, 0, 0.65);
  font-size: 12px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .link {
    cursor: pointer;
    color: var(--main-color);
    text-decoration: underline;
  }
`
const StyledImgBox = styled.div`
  width: 634px;
  height: 507px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`
const StyledLoginTypeBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .text {
    font-size: 12px;
    color: #cbc5c5;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      margin: 0 8px;
    }
    .line {
      width: 68px;
      height: 1px;
      background: rgba(255, 255, 255, 0.12);
    }
  }
`

const StyledWechatLoginTips = styled.div`
  font-size: 12px;
  color: #cbc5c5;
  margin-bottom: 20px;
  text-align: center;
`
const StyledWechatContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  #WeiXinLogin {
    > iframe {
      height: 240px !important;
    }
  }
`
const StyledSwitchBtn = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #cbc5c5;
  cursor: pointer;
  margin: 0 12px;
  &:hover {
    color: var(--main-color);
  }
`

const StyledSwitchRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 11px;
`

const StyledAgreementRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #b5b5b5;
  margin: 22px 0;
  span {
    cursor: pointer;
    &:hover {
      color: var(--main-color);
    }
  }
`
export default hot(observer(Login))
